export default
    [
        {
            path: "/toefl",
            redirect: "listen"
        },
        {
            path: "collection",
            component: () => import("@/views/collection")
        },
        {
            path: "hearingVocabulary",
            component: () => import("@/views/hearingVocabulary/hearingVocabulary.vue")
        },
        {
            path: "listen",
            component: () => import("@/views/toefl/listen/listen.vue")
        },
        {
            path: "read",
            component: () => import("@/views/toefl/read/read.vue")
        }
    ]



// WEBPACK FOOTER //
// ./src/router/children/chil_toefl.js